function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import PropTypes from 'prop-types';
import { Container as DndContainer } from 'react-smooth-dnd';
import { createGlobalStyle } from 'styled-components';
export { Draggable } from 'react-smooth-dnd';
const GlobalStyles = createGlobalStyle`
  .smooth-dnd-container {
    height: 100%;
  }
`;
let count = 0;
export function reset() {
  count = 0;
}
export default function useInstanceCount() {
  return React.useMemo(() => `${count++}`, []);
}
export const DndContext = /*#__PURE__*/React.createContext();
export const Container = ({
  children,
  groupName,
  onDragEnd,
  shouldAcceptDrop = () => true,
  ...rest
}) => {
  const {
    globalOnDragEnd,
    globalShouldAcceptDrop,
    contextId
  } = React.useContext(DndContext) ?? {};
  return /*#__PURE__*/React.createElement(DndContainer, _extends({
    groupName: groupName,
    getChildPayload: sourceStartIndex => ({
      sourceContainerId: groupName,
      sourceStartIndex,
      contextId
    }),
    onDrop: data => {
      if (data.removedIndex === null && data.addedIndex === null) return;
      if (globalOnDragEnd) globalOnDragEnd(groupName, data);else onDragEnd(groupName, data);
    },
    shouldAcceptDrop: (sourceContainerOptions, payload) => {
      if (globalShouldAcceptDrop) return globalShouldAcceptDrop(groupName, sourceContainerOptions, payload);else return shouldAcceptDrop(groupName, sourceContainerOptions, payload);
    }
  }, rest), children);
};
Container.propTypes = {
  children: PropTypes.node,
  groupName: PropTypes.string,
  onDragEnd: PropTypes.func,
  shouldAcceptDrop: PropTypes.func
};
export const DndProvider = ({
  children,
  onDragEnd = () => null,
  shouldAcceptDrop
}) => {
  let contextId = useInstanceCount();
  const defaultShouldAcceptDrop = React.useCallback((groupName, sourceContainerOptions, payload) => {
    if (payload.contextId && payload.contextId !== contextId) return false;
    return typeof shouldAcceptDrop === 'function' ? shouldAcceptDrop(groupName, sourceContainerOptions, payload) : true;
  }, [contextId, shouldAcceptDrop]);
  return /*#__PURE__*/React.createElement(DndContext.Provider, {
    value: {
      globalOnDragEnd: onDragEnd,
      globalShouldAcceptDrop: defaultShouldAcceptDrop,
      contextId
    }
  }, children, /*#__PURE__*/React.createElement(GlobalStyles, null));
};
DndProvider.propTypes = {
  children: PropTypes.node,
  onDragEnd: PropTypes.func,
  shouldAcceptDrop: PropTypes.func
};